import React from "react";

interface AITagProps {
  scaleMultiplier?: number;
  className?: string;
}

const AITag: React.FC<AITagProps> = ({ scaleMultiplier = 1, className = "" }) => {
  const originalWidth = 26;
  const originalHeight = 20;

  const width = originalWidth * scaleMultiplier;
  const height = originalHeight * scaleMultiplier;

  return (
    <svg
      data-testid="ai-tag"
      viewBox="0 0 26 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
    >
      <rect width="100%" height="100%" rx="4" fill="url(#paint0_linear_1178_33320)" />
      <path
        d="M8.4502 5.90039C8.70701 5.90049 8.95701 6.06869 9.06152 6.31836L11.2119 11.4551L11.9277 13.165L11.9688 13.2949C12.0222 13.5562 11.9075 13.8279 11.6895 13.9805L11.5713 14.0459C11.2317 14.1936 10.834 14.0246 10.6875 13.6914L10.6865 13.6895L10.1387 12.3779H6.74316L6.19531 13.6895L6.19434 13.6914C6.0478 14.0248 5.66887 14.1929 5.3125 14.0469L5.31055 14.0459C4.97618 13.9003 4.80508 13.5041 4.9541 13.165L5.66992 11.4551L7.82031 6.31836L7.86621 6.22754C7.98862 6.02737 8.2114 5.90039 8.4502 5.90039ZM7.31055 11.0361H9.58887L8.44922 8.32617L7.31055 11.0361Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
      />
      <path
        d="M19.1602 5.90039C19.5194 5.90039 19.8337 6.21163 19.834 6.57031C19.834 6.94902 19.5175 7.24121 19.1602 7.24121H17.54V12.749H19.1602C19.5195 12.749 19.834 13.0611 19.834 13.4199C19.8338 13.7984 19.5174 14.0898 19.1602 14.0898H14.5732C14.1961 14.0898 13.9006 13.7964 13.9004 13.4199C13.9004 13.0631 14.194 12.7491 14.5732 12.749H16.1934V7.24121H14.5732C14.196 7.24115 13.9004 6.94697 13.9004 6.57031C13.9006 6.21369 14.1941 5.90046 14.5732 5.90039H19.1602Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1178_33320"
          x1="26.9286"
          y1="-12.9167"
          x2="41.1802"
          y2="1.79084"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00614E" />
          <stop offset="1" stopColor="#10DD91" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AITag;
